/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type UpdateLabelCategoryInput = {
    id: string;
    name?: string | null | undefined;
    allowOnPeople?: boolean | null | undefined;
    allowOnProjects?: boolean | null | undefined;
    allowOnTasks?: boolean | null | undefined;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type updateLabelCategoryMutationVariables = {
    input: UpdateLabelCategoryInput;
};
export type updateLabelCategoryMutationResponse = {
    readonly updateLabelCategory: {
        readonly labelCategory: {
            readonly node: {
                readonly id: string;
                readonly name: string | null;
                readonly allowOnTasks: boolean | null;
                readonly allowOnProjects: boolean | null;
                readonly allowOnPeople: boolean | null;
            } | null;
        } | null;
    } | null;
};
export type updateLabelCategoryMutation = {
    readonly response: updateLabelCategoryMutationResponse;
    readonly variables: updateLabelCategoryMutationVariables;
};



/*
mutation updateLabelCategoryMutation(
  $input: UpdateLabelCategoryInput!
) {
  updateLabelCategory(input: $input) {
    labelCategory {
      node {
        id
        name
        allowOnTasks
        allowOnProjects
        allowOnPeople
      }
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateLabelCategoryInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateLabelCategoryPayload",
    "kind": "LinkedField",
    "name": "updateLabelCategory",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "LabelCategoryTypeEdge",
        "kind": "LinkedField",
        "name": "labelCategory",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "LabelCategory",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "allowOnTasks",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "allowOnProjects",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "allowOnPeople",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "updateLabelCategoryMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "updateLabelCategoryMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "updateLabelCategoryMutation",
    "operationKind": "mutation",
    "text": "mutation updateLabelCategoryMutation(\n  $input: UpdateLabelCategoryInput!\n) {\n  updateLabelCategory(input: $input) {\n    labelCategory {\n      node {\n        id\n        name\n        allowOnTasks\n        allowOnProjects\n        allowOnPeople\n      }\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '85486aab425e6e975e6591f75bf85ac8';
export default node;
